import { forwardRef } from 'react';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';
import Skeleton from './Skeleton';

export interface TableBodySkeletonProps {
  rows?: number;
  columns: number;
}

/**
 * A replacement for <TableBody>...</TableBody> when the table data is still loading.
 */
const TableBodySkeleton = forwardRef<HTMLTableSectionElement, TableBodySkeletonProps>(({ columns, rows = 1 }, ref) => {
  return (
    <TableBody ref={ref}>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRow key={`row-${i}`}>
          {Array.from({ length: columns }).map((_, j) => (
            <TableCell key={`cell-${i}-${j}`}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
});

TableBodySkeleton.displayName = 'TableBodySkeleton';

export default TableBodySkeleton;
